import * as Actions from '../Actions/LinkPainelActions';

const initialState = {
    state: false,
    site : "",
};

const LinkPainel = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.TOGGLE_LINK_PAINEL:
        {
            return {
                ...state,
                state: !state.state,
                site : action.site

            };
        }
        default:
        {
            return state;
        }
    }
};

export default LinkPainel;
